import React from "react";

const vehicleDriversLicense = `<div align="center" id="coverageContainer">

<table width="98%" border="0" cellspacing="0" cellpadding="0" style="">
<tbody>
	<tr>
		<td style="width:0%;padding:0;">
			<div style="margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;">&nbsp;</span></font></div>
		</td>
		<td colspan="2" style="padding:7.5pt;"></td>
	</tr>
	<tr>
		<td colspan="2" style="">
			<div align="center" style="margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" size="2" color="#333333"><span style="font-size:10pt;"><b>Driver Licenses Coverage Area</b></span></font></span></font></div>
		</td>
		<td style="padding:0;"></td>
	</tr>
</tbody>
</table>

<div style="margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" color="#333333">&nbsp;</font></span></font></div>
<!-- government sources -->
<div align="center" style="text-align:center;">
<table width="98%" border="0" cellspacing="0" cellpadding="0" style="">
<tbody>
	<tr>
		<td colspan="2" valign="top" style="padding:0;">
			<div style="margin:0 0 12pt 0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><b>STATES COVERED:</b></span></font></span></font></div>
		</td>
	</tr>
	<tr>
		<td colspan="2" valign="top" style="padding:0;">
			<div style="margin:0 0 12pt 0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><b>Governmental Sources</b></span></font></span></font></div>
		</td>
	</tr>
	<tr>
	<td valign="top" style="width:50%;padding:0;">
		<div style="margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;">CONNECTICUT</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		COLORADO </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		DELAWARE </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		FLORIDA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		IDAHO </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		ILLINOIS </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		KENTUCKY </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		LOUISIANA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		MAINE</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		MASSACHUSETTS </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		MICHIGAN</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		MINNESOTA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		MISSISSIPPI </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"></span></font></div>
	</td>
	<td valign="top" style="width:50%;padding:0;">
		<div style="margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;">MISSOURI</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		NEBRASKA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		NEW HAMPSHIRE </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		NORTH CAROLINA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		NORTH DAKOTA </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		OHIO</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		SOUTH CAROLINA </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		TENNESSEE</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		TEXAS</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		WEST VIRGINIA </span></font><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		WISCONSIN</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

		WYOMING</span></font></span></font>
		</div>
	</td>
	</tr>
</tbody>
</table>
</div>
<div align="center" style="text-align:center;margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" color="#333333">&nbsp;</font></span></font></div>
<!-- non-goverment sources -->

<div align="center" style="text-align:center;">
<table width="98%" border="0" cellspacing="0" cellpadding="0" style="width:98%;">
<tbody>
	<tr>
		<td colspan="2" valign="top" style="padding:0;">
		<div style="margin:0 0 12pt 0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><b>Non Governmental Sources</b></span></font></span></font></div>
		</td>
	</tr>
	<tr>
		<td valign="top" style="width:50%;padding:0;">
			<div style="margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;">ALABAMA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			ALASKA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			ARIZONA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			ARKANSAS</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			CALIFORNIA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			COLORADO</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			CONNECTICUT</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			DISTRICT OF COLUMBIA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			DELAWARE</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			FLORIDA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			GEORGIA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			HAWAII</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			IDAHO</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			ILLINOIS</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			INDIANA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			IOWA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			KANSAS</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			KENTUCKY</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			LOUISIANA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			MAINE</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			MASSACHUSETTS</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			MICHIGAN</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			MINNESOTA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			MISSISSIPPI</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			MISSOURI</span></font></span></font>
			</div>
		</td>
		<td valign="top" style="width:50%;padding:0;">
			<div style="margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;">MONTANA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			NEBRASKA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			NORTH CAROLINA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			NORTH DAKOTA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			NEW HAMPSHIRE</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			NEW JERSEY</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			NEW MEXICO</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			NEW YORK</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			NEVADA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			OKLAHOMA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			OHIO</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			OREGON</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			PENNSYLVANIA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			RHODE ISLAND</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			SOUTH CAROLINA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			SOUTH DAKOTA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			TENNESSEE</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			TEXAS</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			UTAH</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			VERMONT</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			VIRGINIA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			WASHINGTON</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			WISCONSIN</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			WEST VIRGINIA</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			WYOMING</span></font></span></font>
			</div>
		</td>
	</tr>
</tbody>
</table>
</div>

<div align="center" style="text-align:center;margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><font face="Arial, Helvetica, sans-serif" color="#333333">&nbsp;</font></span></font></div>
<div align="center" style="text-align:center;">
<table width="98%" border="0" cellspacing="0" cellpadding="0" style="width:98%;">
<tbody>
<tr>
	<td style="padding:0;">
		<div style="margin:0;"><font face="Arial, Helvetica, sans-serif" size="2"><span style="font-size:11pt;"><img src="images/asterick_image001.gif" alt="" height="10" width="11"><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;">Historical
			Data Only. </span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><br>

			</span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;"><b>NOTE:</b></span></font><font face="Arial, Helvetica, sans-serif" size="1" color="#333333"><span style="font-size:8pt;">&nbsp; Due to contractual and regulatory restrictions,
			some of the states listed above may not be available to you. </span></font></span></font>
		</div>
	</td>
</tr>
</tbody>
</table>
</div>

</div>
`;

export const vehicleDriversLicenseContent = (
  <div
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: vehicleDriversLicense
    }}
  />
);

export default vehicleDriversLicenseContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/VehicleDriversLicense.js